import { call, put, takeEvery } from 'redux-saga/effects';
import * as ActionTypes from './types';
import * as Actions from './actions';
import ProviderConfigurationsApi from '../api/ProviderConfigurationsApi';
import BusinessUnitsApi from '../api/BusinessUnitsApi';
import SftpApi from '../api/SftpApi';
import ResourceTypes from '../resourceTypes';
const { addError } = window.zooz_message;
const initializeSaga = (includedResources) => {
    function* fetchContextData() {
        yield put(Actions.setIsFetchingResources(true));
        for (const resource of includedResources) {
            switch (resource) {
                case ResourceTypes.ProviderConfigurations: {
                    try {
                        yield put(Actions.setIsFetchingProviderConfigs(true));
                        const providerConfigurations = yield call(ProviderConfigurationsApi.fetchProviderConfigurations);
                        yield put(Actions.fetchProviderConfigurationsSuccess(providerConfigurations));
                        yield put(Actions.setIsFetchingProviderConfigs(false));
                    }
                    catch (err) {
                        yield call(addError, err);
                        yield put(Actions.setIsFetchingProviderConfigs(false));
                    }
                    break;
                }
                case ResourceTypes.BusinessUnits: {
                    try {
                        yield put(Actions.setIsFetchingBusinessUnits(true));
                        const businessUnits = yield call(BusinessUnitsApi.fetchBusinessUnits);
                        yield put(Actions.fetchBusinessUnitsSuccess(businessUnits));
                        yield put(Actions.setIsFetchingBusinessUnits(false));
                    }
                    catch (err) {
                        yield call(addError, err);
                        yield put(Actions.setIsFetchingBusinessUnits(false));
                    }
                    break;
                }
                case ResourceTypes.SftpFolders: {
                    try {
                        yield put(Actions.setIsFetchingSftpFolders(true));
                        const sftpFolders = yield call(SftpApi.fetchFolders);
                        yield put(Actions.fetchSftpFoldersSuccess(sftpFolders));
                        yield put(Actions.setIsFetchingSftpFolders(false));
                    }
                    catch (err) {
                        yield put(Actions.setIsFetchingSftpFolders(false));
                    }
                    break;
                }
            }
        }
        yield put(Actions.setIsFetchingResources(false));
    }
    return function* contextDataSaga() {
        yield takeEvery(ActionTypes.CONTEXT_DATA_FETCH_RESOURCES, fetchContextData);
    };
};
export default initializeSaga;
